import React from 'react';
import Section, { FadeIn } from './ui/Section';
import SafeIcon from '../common/SafeIcon';

const Problem = () => {
  return (
    <Section className="bg-brand-gray relative">
      <div className="max-w-4xl mx-auto">
        <FadeIn>
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 tracking-tight">
            You Keep <span className="text-red-600 underline decoration-red-200 underline-offset-4">Misunderstanding</span> Each Other
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <FadeIn delay={0.1} className="space-y-6 text-lg text-gray-700 bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="bg-gray-100 p-3 rounded-full mt-1">
                <SafeIcon name="MessageSquare" className="text-gray-600 w-5 h-5" />
              </div>
              <div>
                <p className="font-semibold text-brand-dark">He said "I'm fine."</p>
                <p className="text-gray-500 line-through decoration-red-400">You heard "Leave me alone."</p>
                <p className="text-green-600 font-medium mt-2">He meant "I need 20 minutes to process, then I'm yours."</p>
              </div>
            </div>
            <div className="pt-4 border-t border-gray-100">
              <p className="font-medium text-brand-dark italic">
                Three hours later, you're in a fight about nothing. Again.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="space-y-6">
            <p className="text-xl font-medium leading-relaxed text-brand-dark">
              The real problem: You're speaking different languages — and nobody gave you the dictionary.
            </p>
            <p className="text-gray-600">
              Every day, good relationships end because of 10 simple phrases. Same words. Opposite meanings. Both people hurt.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.3}>
          <div className="bg-brand-dark text-white rounded-2xl p-8 md:p-12 shadow-xl">
            <h3 className="text-2xl font-bold mb-6 text-brand-yellow flex items-center gap-3">
              <SafeIcon name="AlertTriangle" /> The Cost of Guessing
            </h3>
            <ul className="space-y-4">
              {[
                "Nights analyzing texts instead of sleeping",
                "Fights that start over \"nothing\"",
                "Love lost to misunderstanding"
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-lg">
                  <SafeIcon name="XCircle" className="text-red-400 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 pt-8 border-t border-white/10">
              <p className="text-xl font-medium">
                You don't need another communication book. You need translations for the specific moments that destroy relationships.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>
  );
};

export default Problem;